module.exports = "/assets/archetype-grief.webp"